import { hamburgerMenuVariants } from './HamburgerMenu.cva';

export interface HamburgerMenuProps {
  className?: string;
  isOpen: boolean;
  onToggle: () => void;
}

export function HamburgerMenu({ className, isOpen, onToggle }: HamburgerMenuProps) {
  return (
    <button
      className={hamburgerMenuVariants({ isOpen, className })}
      onClick={onToggle}
      aria-expanded={isOpen}
    >
      <span className="hamburger-line bg-[#DC0D15]" />
      <span className="hamburger-line bg-black" />
      <span className="hamburger-line bg-[#DC0D15]" />
    </button>
  );
}

export default HamburgerMenu;
